import React, { useState } from "react";

import {
    DialogTitle,
    DialogActions,
    Button,
    DialogContent,
    Dialog,
} from "@mui/material";

import FormBuilder from "../../../Common/FormBuilder/FormBuilder";

function TermFormDialog(props) {
    const [form, setForm] = useState(props.term.form);

    const handleUpdate = ({ elements }) =>
        setForm({
            ...form,
            elements: [
                ...form.elements.filter(
                    ({ id }) => Number(id) !== Number(elements[0].id)
                ),
                ...elements,
            ],
        });

    const handleSubmit = () => {
        props.onSubmit(form);
        props.onClose();
    };

    return (
        <Dialog
            open={!!props.open}
            onClose={props.onClose}
            fullWidth={true}
            maxWidth="md"
        >
            <DialogTitle>{props.term.title}</DialogTitle>
            <DialogContent dividers={false}>
                {!!props?.term?.form && (
                    <FormBuilder
                        form={props.term.form}
                        canUpdate={props.term.canUpdate}
                        onFieldChange={handleUpdate}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button key="cancel" onClick={props.onClose}>
                    Cancel
                </Button>
                <Button
                    key="upload"
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    onClick={handleSubmit}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default TermFormDialog;
